// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "../../application"

// Manually imported shared controllers
import AccordionController from "../../shared/accordion_controller"
application.register("accordion", AccordionController)
import AutosizeController from "../../shared/autosize_controller"
application.register("autosize", AutosizeController)
import CurrentPopperController from "../../shared/current_popper_controller"
application.register("current-popper", CurrentPopperController)
import ExpandableController from "../../shared/expandable_controller"
application.register("expandable", ExpandableController)
import FormController from "../../shared/form_controller"
application.register("form", FormController)
import PopperController from "../../shared/popper_controller"
application.register("popper", PopperController)

// Auto-generated controller imports
import FixedSidebarController from "./fixed_sidebar_controller"
application.register("fixed-sidebar", FixedSidebarController)
import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)
import MapController from "./map_controller"
application.register("map", MapController)
import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)
